<button class="btn btn-primary rounded-circle shadow-lg d-flex justify-content-center align-items-center"
  style="width: 50px; height: 50px; position: absolute; top: 20px; right: 20px; z-index: 50;" type="button"
  (click)="toggleOffcanvas()">
  <i class="bi bi-card-text fs-4"></i>
</button>
<!-- OFFCANVAS -->
<div class="offcanvas offcanvas-end custom-offcanvas" [class.is-wide]="changeInfo" tabindex="-1" id="offcanvasRight">
  <!-- HEADER -->
  <div class="total_header">
    <!-- CONTENUTO HEADER-->
    <div class="">

      <span class="text-uppercase small fw-semibold opacity-75">
        Scheda intervento
      </span>

      <h3 class="mt-1 mb-1 fw-bold">
        {{ attributes?.wr_site_name || 'N/D' }}
      </h3>

      <div class="d-flex align-items-center gap-2 small opacity-90">
        <i class="fa-solid fa-location-dot"></i>
        <span>
          {{ attributes?.wr_site_name || 'Informazione mancante' }}
        </span>
      </div>

      <div class="mt-2 d-flex gap-2 flex-wrap">
        <span class="badge bg-white text-dark">
          {{ attributes?.wr_netwrk_ref || 'N/D' }}
        </span>
        <span class="badge bg-white text-dark">
          {{ attributes?.wr_geo_area || 'N/D' }}
        </span>
      </div>

    </div>
    @if(changeInfo){
    <div class="offcanvas-header">
      <button class="btn-header btn-header-back" (click)="changeInfo = false" title="Torna al riepilogo">
        <i class="bi bi-arrow-left"></i>
      </button>

      <button class="btn-header btn-header-close" (click)="toggleOffcanvas()" title="Chiudi">
        <i class="bi bi-x-lg"></i>
      </button>

    </div>
    }
  </div>
  <!-- BODY -->
  <div class="offcanvas-body p-0 d-flex flex-column">
    @if (!changeInfo) {
    <div class="flex-grow-1 overflow-auto">
      <div class="border-0 shadow-sm overflow-hidden">
        <div style="height:180px; width:100%;">
          @if(getNetworkImages().length > 0){
          <img [src]="getNetworkImages()[0]" alt="Rete {{ attributes?.wr_netwrk_ref }}" style="
        width:100%;
        height:100%;
        object-fit:cover;
        display:block;
      " />
          }
        </div>

      </div>

      <!-- AVANZAMENTO -->

      <div class="segmented-wrapper mb-2 text-center mt-4 flex align-items-center">
        <!-- barra -->
        <div class="segmented-bar" [ngClass]="getBarClass()">
          <span *ngFor="let _ of phaseSegments; let idx = index" class="segment"
            [class.active]="idx < getActiveSegments()">
          </span>
        </div>
      </div>

      @if (currentPhaseUi; as phase) {
      <div class="text-center mb-4">
        <div class="d-flex justify-content-center align-items-center gap-2 mb-1">
          <span class="badge bg-primary px-3 py-2">
            {{ phase.number }}
          </span>
        </div>

        <div class="text-muted small fw-semibold">
          {{ phase.title }}
        </div>
      </div>
      } @else {
      <div class="text-center text-muted small mb-4">
        Fase non disponibile
      </div>
      }
      <div class="p-3 mb-4 rounded-md text-center alertBadge" [ngClass]="getCriticalBoxClass()">
        <div class="flex justify-content-center align-items-center gap-2 font-bold">
          <i class="pi pi-exclamation-triangle"></i>
          CRITICITÀ: {{ critical || 'Non rilevata' }}
        </div>
      </div>



      <!-- ANAGRAFICA -->
      <div class="p-4">
        <div class="flex align-items-center justify-content-between gap-3 mb-2">
          <strong class="text-gray-500">ID Sito:</strong>
          {{ attributes?.wr_id_site || '-' }}
        </div>

        <div class="flex align-items-center justify-content-between gap-3 mb-2">
          <strong class="text-gray-500">Tipologia Rete:</strong>
          {{ attributes?.wr_netwrk_ref || '-' }}
        </div>

        <div class="flex align-items-center justify-content-between gap-3 mb-2">
          <strong class="text-gray-500">Ente Beneficiario:</strong>
          {{ attributes?.wr_authority || '-' }}
        </div>

        <div class="flex align-items-center justify-content-between gap-3 mb-2">
          <strong class="text-gray-500">Stato Lavorazione:</strong>
          {{ attributes?.wr_work_state || '-' }}
        </div>

        <div class="flex align-items-center justify-content-between gap-3 mb-2">
          <strong class="text-gray-500">Latitudine:</strong>
          {{ attributes?.wr_latitudine || '-'}}
        </div>
        <div class="flex align-items-center justify-content-between gap-3 mb-2">
          <strong class="text-gray-500">Longitudine:</strong>
          {{ attributes?.wr_longitudine || '-'}}
        </div>

        <div class="flex align-items-center justify-content-between gap-3 mb-2">
          <strong class="text-gray-500">Altitudine:</strong>
          {{ attributes?.wr_altitude || '-' }}
        </div>

        <div class="flex align-items-center justify-content-between gap-3 mb-2">
          <strong class="text-gray-500">Provincia:</strong>
          {{ attributes?.wr_county || '-' }}
        </div>

        <div class="flex justify-content-between gap-3 mb-2">
          <strong class="text-gray-500">Indirizzo:</strong>
          <span class="text-end">{{ attributes?.wr_address || '-' }}</span>
        </div>

        <div class="flex justify-content-between gap-3 mb-2">
          <strong class="text-gray-500">Località:</strong>
          <span class="text-end">{{ attributes?.wr_locality || '-' }}</span>
        </div>

      </div>
    </div>
    <div class="p-3 border-top">
      <button class="btn btn-primary w-100" (click)="changeInfo = true">
        Gestione completa
      </button>
    </div>
    } @else {
    <!-- ================= SCHEDA COMPLETA ================= -->
    <div class="flex-grow-1 overflow-auto">
      <ul class="nav nav-tabs px-3 mt-2">
        <li class="nav-item">
          <button class="nav-link" [class.active]="activeTab === 'avanzamento'" (click)="setActiveTab('avanzamento')">
            Avanzamento
          </button>
        </li>

        <li class="nav-item">
          <button class="nav-link" [class.active]="activeTab === 'documenti'" (click)="setActiveTab('documenti')">
            Documenti ({{ documents.length }})
          </button>
        </li>

        <li class="nav-item">
          <button class="nav-link" [class.active]="activeTab === 'criticita'" (click)="setActiveTab('criticita')">
            Criticità
          </button>
        </li>

        <li class="nav-item">
          <button class="nav-link" [class.active]="activeTab === 'computo'" (click)="setActiveTab('computo')">
            Computo metrico
          </button>
        </li>

        <li class="nav-item">
          <button class="nav-link" [class.active]="activeTab === 'assets'" (click)="setActiveTab('assets')">
            Assets
          </button>
        </li>
      </ul>

      <div class="tab-content p-4">
        <!-- Avanzamento -->
        @if(activeTab === 'avanzamento'){
        <div>

          <!-- badge stato -->
          <div class="flex align-items-center">
            <span class="text-gray-500 text-xl me-1">Stato:</span>

            <span class="state-badge">
              {{ getStatusText() }}
            </span>

          </div>

          <!-- ================= CRONOPROGRAMMA FASI ================= -->
          <div class="mt-4">

            <h6 class="fw-bold mb-3">
              <i class="bi bi-calendar-check me-2 text-primary"></i>
              Cronoprogramma fasi
            </h6>

            <!-- LINEA -->
            <div class="position-relative d-flex justify-content-between align-items-start">

              <!-- linea base -->
              <div class="position-absolute w-100" style="top:22px;height:3px;background:#E5E7EB;z-index:0">
              </div>

              <!-- linea avanzamento -->
              <div class="position-absolute" style="top:22px;height:3px;background:#22C55E;z-index:1"
                [style.width.px]="phaseProgressPx">
              </div>

              <!-- FASI -->
              @for (phase of getPhasesOrdered(); track phase.objectid) {

              @let current = getCurrentPhaseNumber();

              <div class="text-center position-relative" style="z-index:2;width:16%">

                <!-- CERCHIO -->
                <div class="mx-auto mb-2 d-flex align-items-center justify-content-center
                 rounded-circle phase-circle" [ngClass]="{
            'bg-success text-white': isPhaseCompleted(phase),
            'border border-3 border-primary phase-next':
              phase.wr_phase_number === current,
            'bg-gray-100 text-muted':
              !isPhaseCompleted(phase) && phase.wr_phase_number !== current
          }" style="width:44px;height:44px;font-weight:700">

                  @if (isPhaseCompleted(phase)) {
                  <i class="fa-solid fa-check"></i>
                  } @else {
                  {{ phase.wr_phase_number }}
                  }

                </div>

                <!-- TITOLO -->
                <div class="fw-bold text-uppercase small" [ngClass]="{
            'text-primary': phase.wr_phase_number === current,
            'text-muted': phase.wr_phase_number !== current
          }">
                  Fase {{ phase.wr_phase_number }}
                </div>

                <!-- DESCRIZIONE -->
                <div class="small fw-semibold mt-1" [ngClass]="{
            'text-primary': phase.wr_phase_number === current,
            'text-muted': phase.wr_phase_number !== current
          }">
                  {{ phase.wr_title || 'Descrizione non disponibile' }}
                </div>

                <!-- STATO -->
                @if (phase.wr_phase_number === current) {
                <div class="small fw-bold text-primary mt-1">
                  In corso
                </div>
                }

                <!-- LINK -->
                @if (phase.wr_permalink) {
                <a [href]="phase.wr_permalink" target="_blank"
                  class="text-primary small d-inline-flex align-items-center gap-1 mt-1">
                  <i class="fa-solid fa-arrow-up-right-from-square"></i>
                  Dettaglio
                </a>
                }

              </div>
              }
            </div>
          </div>

          <!-- ================= INFO SITO ================= -->
          <div class="mt-5">

            <h6 class="fw-bold mb-3 d-flex align-items-center gap-2">
              <i class="bi bi-info-circle-fill text-primary"></i>
              Legenda fasi intervento
            </h6>

            <div class="table-responsive">
              <table class="table table-bordered align-middle small">

                <thead class="table-light">
                  <tr>
                    <th style="width: 80px;">Fase</th>
                    <th style="width: 220px;">Titolo fase</th>
                    <th>Attività principali</th>
                    <th style="width: 160px;">Stato</th>
                  </tr>
                </thead>

                <tbody>
                  <!-- FASE 1 -->
                  <tr>
                    <td class="fw-bold">1</td>
                    <td class="fw-semibold">
                      Nomina responsabili<br>
                      <span class="text-muted">Stazione Appaltante</span>
                    </td>
                    <td>
                      Nomina CSP/CSE<br>
                      Direttore Operativo<br>
                      Direttore Lavori<br>
                      Collaudatore / Verificatore
                    </td>
                    <td>
                      <span class="bar-neutral">
                        <span class="state-badge">Da avviare</span>
                      </span>
                    </td>
                  </tr>

                  <!-- FASE 2 -->
                  <tr>
                    <td class="fw-bold">2</td>
                    <td class="fw-semibold">
                      Nomina responsabili<br>
                      <span class="text-muted">Appaltatore</span>
                    </td>
                    <td>
                      Direttore Tecnico di Cantiere<br>
                      RSPP e Preposto Sicurezza<br>
                      Responsabile Qualità e Ambiente<br>
                      Referente contabilità lavori
                    </td>
                    <td>
                      <span class="bar-neutral">
                        <span class="state-badge">Da avviare</span>
                      </span>
                    </td>
                  </tr>

                  <!-- FASE 3 -->
                  <tr>
                    <td class="fw-bold">3</td>
                    <td class="fw-semibold">
                      Attività propedeutiche
                    </td>
                    <td>
                      Autorizzazione lavori<br>
                      Controllo sicurezza<br>
                      Verbale avvio lavori<br>
                      Sopralluogo iniziale<br>
                      Progetto esecutivo
                    </td>
                    <td>
                      <span class="bar-info">
                        <span class="state-badge">In progettazione</span>
                      </span>
                    </td>
                  </tr>

                  <!-- FASE 4 -->
                  <tr>
                    <td class="fw-bold">4</td>
                    <td class="fw-semibold">
                      Esecuzione dei lavori
                    </td>
                    <td>
                      Allestimento cantiere<br>
                      Controllo qualità e sicurezza<br>
                      Varianti in corso d’opera<br>
                      Pagamenti e verifiche<br>
                      Test propedeutici al collaudo
                    </td>
                    <td>
                      <span class="bar-primary">
                        <span class="state-badge">In esecuzione</span>
                      </span>
                      <br>
                      <span class="bar-orange mt-1 d-inline-block">
                        <span class="state-badge">In verifica</span>
                      </span>
                    </td>
                  </tr>

                  <!-- FASE 5 -->
                  <tr>
                    <td class="fw-bold">5</td>
                    <td class="fw-semibold">
                      Consuntivazione
                    </td>
                    <td>
                      Verifica finale e collaudo<br>
                      Certificazione conformità tecnica<br>
                      Registro riserve<br>
                      Relazione finale DEC
                    </td>
                    <td>
                      <span class="bar-green">
                        <span class="state-badge">Connessi</span>
                      </span>
                      <br>
                      <span class="bar-success mt-1 d-inline-block">
                        <span class="state-badge">Collaudati</span>
                      </span>
                    </td>
                  </tr>

                  <!-- FASE 6 -->
                  <!-- <tr>
                    <td class="fw-bold">6</td>
                    <td class="fw-semibold">
                      Certificazioni
                    </td>
                    <td>
                      CE – DoC – NOS<br>
                      ISO/IEC 27001 – ISO 50001<br>
                      RoHS – REACH<br>
                      EMC – Certificazioni specialistiche
                    </td>
                    <td>
                      <span class="bar-purple">
                        <span class="state-badge">Certificazioni</span>
                      </span>
                    </td>
                  </tr> -->

                </tbody>
              </table>
            </div>
          </div>


        </div>
        }
        <!-- DOCUMENTI -->
        @if(activeTab === 'documenti'){
        <div>
          <h5 class="fw-bold mb-4 uppercase">
            Documentazione
          </h5>
          <div class="row g-3">
            @for (d of documents; track $index) {
            <div class="col-12">
              <div class="card document-card border-0 shadow-sm">
                <div
                  class="card-body d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-3">

                  <!-- LEFT -->
                  <div class="d-flex align-items-start align-items-md-center gap-3">

                    <div class="doc-icon flex-shrink-0">
                      <i class="bi bi-file-earmark-text"></i>
                    </div>

                    <div>
                      <div class="fw-semibold">
                        {{ d.wr_title }}
                      </div>

                      <div class="text-muted small">
                        Documento collegato al sito
                      </div>
                    </div>

                  </div>

                  <!-- CTA -->
                  <a *ngIf="emissionDate(d)" class="btn btn-primary btn-sm
         w-full md:w-fit
         align-self-stretch align-self-md-center" [href]="d.wr_permalink" target="_blank">
                    <i class="bi bi-box-arrow-up-right me-1"></i>
                    Apri
                  </a>



                </div>
              </div>


            </div>
            }

          </div>
        </div>
        }
        <!-- CRITICITÀ -->
        @if (activeTab === 'criticita') {
        <div>

          <!-- ================= HEADER ================= -->
          <div class="d-flex align-items-center justify-content-between mb-4">
            <div class="d-flex align-items-center gap-3">
              <div>
                <h5 class="fw-bold m-0 uppercase">Criticità del sito</h5>
                <span class="text-muted small">
                  Monitoraggio del rischio operativo
                </span>
              </div>
            </div>

            @if (critical === 'Alta') {
            <span class="status-pill danger">
              Attenzione criticità elevata
            </span>
            }
          </div>

          <!-- ================= HERO CARD ================= -->
          <div class="critical-hero d-flex align-items-center gap-4">

            <!-- CERCHIO ISTITUZIONALE CON ICONA -->
            <div class="critical-circle" [ngClass]="getDonutClass()">
              <svg viewBox="0 0 100 100">

                <!-- cerchio esterno -->
                <circle cx="50" cy="50" r="46" fill="none" stroke="currentColor" stroke-width="2" opacity="0.4" />

                <!-- cerchio interno -->
                <circle cx="50" cy="50" r="26" fill="currentColor" opacity="0.18" />

                <!-- ICONE -->
                <!-- ALTA -->
                <g *ngIf="critical === 'Alta'" fill="currentColor" transform="translate(50 50)">
                  <path d="M0,-16 L18,16 H-18 Z" opacity="0.8" transform="scale(0.8)" />
                  <rect x="-2" y="-2" width="4" height="8" fill="#fff" />
                  <circle cx="0" cy="10" r="2" fill="#fff" />
                </g>

                <!-- MEDIA -->
                <g *ngIf="critical === 'Media'" stroke="currentColor" stroke-width="4" stroke-linecap="round"
                  transform="translate(50 50)">
                  <line x1="-14" y1="0" x2="14" y2="0" />
                </g>

                <!-- BASSA -->
                <g *ngIf="critical === 'Bassa'" stroke="currentColor" stroke-width="4" stroke-linecap="round"
                  transform="translate(50 50)">
                  <polyline points="-10,0 -2,8 12,-8" fill="none" />
                </g>

              </svg>
            </div>

            <!-- TESTO -->
            @if (critical) {
            <div class="alert d-flex align-items-center gap-2" [ngClass]="{
              'alert-danger-soft': critical === 'Alta',
              'alert-warning-soft': critical === 'Media',
              'alert-info': critical === 'Bassa'
            }">
              <strong>Criticità:</strong> {{ critical }}
            </div>
            } @else {
            <div class="alert alert-info d-flex align-items-center gap-2">
              <i class="bi bi-info-circle-fill"></i>
              <strong>Nessuna criticità rilevata</strong>
            </div>
            }


          </div>

          <!-- ================= WRiKE ================= -->
          @if (criticals.length > 0) {
          <div class="mt-4">

            <h6 class="fw-bold mb-2 uppercase text-muted">
              Dettaglio criticità
            </h6>

            @for (c of criticals; track c.wrike_id) {
            <div class="card border-0 shadow-sm mb-3 wrike-card">
              <div class="card-body d-flex align-items-start gap-3">

                <!-- ICONA -->
                <div class="icon-wrapper primary wrike-icon">
                  <i class="bi bi-kanban-fill"></i>
                </div>

                <!-- CONTENUTO -->
                <div class="flex-grow-1">

                  <!-- HEADER: titolo + stato -->
                  <div class="d-flex align-items-center justify-content-between gap-2 mb-1">

                    <!-- TITOLO -->
                    <div class="fw-semibold wrike-title">
                      {{ c.wr_title }}
                    </div>

                    <!-- STATO -->
                    @if (c.wr_status) {
                    <span class="badge rounded-pill bg-light text-dark wrike-status">
                      {{ c.wr_status }}
                    </span>
                    }
                  </div>

                  <!-- LINK -->
                  @if (c.wr_permalink) {
                  <a [href]="c.wr_permalink" target="_blank" rel="noopener noreferrer" class="wrike-link">
                    Apri in Wrike
                    <i class="bi bi-arrow-up-right ms-1"></i>
                  </a>
                  }

                </div>

              </div>
            </div>

            }

          </div>
          }
        </div>
        }

        <!-- COMPUTO METRICO -->
        @if(activeTab === 'computo'){
        <div>
          <h5 class="fw-bold mb-4 text-uppercase">
            Dettaglio computo metrico estimativo
          </h5>

          <div class="table-responsive">
            <table class="table table-hover align-middle computo-table">

              <thead class="table-light">
                <tr>
                  <th>Titolo</th>
                  <th>Rete</th>
                  <th>Categoria merc.</th>
                  <th>Specifiche tecniche</th>
                  <th class="text-center">Q.tà</th>
                </tr>
              </thead>

              <tbody>
                @for (m of metricCalculations; track $index) {
                <tr>

                  <td>
                    {{ m.wr_tipo_fab || 'N/D' }}
                  </td>

                  <td class="text-primary">
                    {{ m.wr_item_rete || 'N/D' }}
                  </td>

                  <td class="fw-semibold">
                    {{ m.wr_cat_merc || 'N/D' }}
                  </td>

                  <td class="text-muted small">
                    <div class="spec-text" [class.expanded]="m.__expanded">
                      {{ m.wr_spec_tec || 'Descrizione non disponibile' }}
                    </div>

                    @if(m.wr_spec_tec && m.wr_spec_tec.length > 120){
                    <a href="javascript:void(0)" class="spec-toggle" (click)="m.__expanded = !m.__expanded">
                      {{ m.__expanded ? 'Meno' : 'Altro' }}
                    </a>
                    }
                  </td>
                  <td class="text-center fw-semibold">
                    {{ m.wr_quant_oda || '-' }}
                  </td>

                </tr>
                }
              </tbody>

            </table>
          </div>

        </div>
        }
        <!-- ASSETS -->
        @if(activeTab === 'assets'){
        <div>
          <h5 class="fw-bold mb-4 text-uppercase">
            Informazioni relative agli asset
          </h5>

          <div class="table-responsive">
            <table class="table table-hover align-middle computo-table">

              <thead class="table-light">
                <tr>
                  <th>Serial number</th>
                  <th>Titolo</th>
                  <th>Part number</th>
                  <th>Produttore</th>
                  <th>Fornitore</th>
                  <!-- <th>Descrizione</th> -->
                </tr>
              </thead>

              <tbody>
                @for (m of assets; track $index) {
                <tr>

                  <td class="fw-semibold">
                    {{ m.wr_serial_num || 'Informazione mancante' }}
                  </td>

                  <td>
                    {{ m.wr_title || 'Informazione mancante' }}
                  </td>

                  <td class="fw-semibold">
                    {{ m.wr_part_num || 'Informazione mancante' }}
                  </td>

                  <td>
                    {{ m.wr_producer || 'Informazione mancante' }}
                  </td>

                  <td>
                    {{ m.wr_supplier || 'Informazione mancante' }}
                  </td>
                  <!-- <th>{{m.wr_description || 'Nessuna descrizione'}}</th> -->

                </tr>
                }
              </tbody>

            </table>
          </div>
        </div>
        }


      </div>
    </div>
    }

  </div>
</div>